import * as React from "react";
import { Product } from "@/types/product";
import { calculateStats } from "./utils/searchUtils";

interface SearchStatsProps {
  query: string;
  totalHits: number;
  suggestions: Product[];
}

export const SearchStats = ({ query, totalHits, suggestions }: SearchStatsProps) => {
  if (query.length < 2) return null;

  const stats = calculateStats(suggestions);

  return (
    <div className="flex flex-wrap gap-4 text-sm text-gray-600 dark:text-gray-400 mt-2">
      <div>Found {totalHits} {totalHits === 1 ? 'result' : 'results'}</div>
      <div>Average Price: €{stats.avgPrice.toFixed(2)}</div>
      <div>Total Ratings: {stats.totalRatings.toLocaleString()}</div>
      <div>Average Rating: {stats.avgRating.toFixed(1)} / 5</div>
    </div>
  );
};